import { AppShell, Center, Loader } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Navigate, Outlet } from 'react-router-dom';
import { useOnboardingComplete } from '../../hooks/useOnboardingComplete';
import { PortalSidebar } from './PortalSidebar';
import { PortalHeader } from './PortalHeader';

export function PortalLayout() {
  const { isOnboardingComplete, isLoading } = useOnboardingComplete();
  const [sidebarOpen, { toggle: toggleSidebar }] = useDisclosure();

  if (isLoading) {
    return (
      <Center h="100vh" bg="var(--color-bg-primary)">
        <Loader color="cyan" size="lg" />
      </Center>
    );
  }

  if (!isOnboardingComplete) {
    return <Navigate to="/onboarding" replace />;
  }

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{ width: 260, breakpoint: 'sm', collapsed: { mobile: !sidebarOpen } }}
      padding="lg"
      styles={{
        main: {
          backgroundColor: 'var(--color-bg-primary)',
          minHeight: '100vh',
        },
        header: {
          backgroundColor: 'rgba(10, 15, 30, 0.8)',
          backdropFilter: 'blur(12px)',
          borderBottom: '1px solid rgba(0, 240, 255, 0.1)',
        },
        navbar: {
          backgroundColor: 'rgba(10, 15, 30, 0.6)',
          backdropFilter: 'blur(16px)',
          borderRight: '1px solid rgba(0, 240, 255, 0.1)',
        },
      }}
    >
      <AppShell.Header>
        <PortalHeader onBurgerClick={toggleSidebar} sidebarOpen={sidebarOpen} />
      </AppShell.Header>
      <AppShell.Navbar>
        <PortalSidebar />
      </AppShell.Navbar>
      <AppShell.Main>
        <div className="max-w-6xl mx-auto animate-fade-in">
          <Outlet />
        </div>
      </AppShell.Main>
    </AppShell>
  );
}
